import styled from "styled-components";

export const StyledLabel = styled.label`
  border: 1.5px solid ${props => props.theme.colors.body};
  border-radius: 40px;
  display: flex;
  height: 34px;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px; 

  transition: all 0.5s;

  &:hover{
    cursor: pointer;
  }

  &:active {
    border-color: ${props => props.theme.colors.placeholder};
    .label {
      color: ${props => props.theme.colors.placeholder} !important;
    }
  }

  .label {
    text-transform: capitalize;
    transition: all 0.5s;

  }
`;

export const InputFile = styled.input.attrs({ type: "file" })`
  display: none;
`;